/* src/app/modules/shared/components/header-column/header-column-growing-conditions/header-column-growing-conditions.component.scss */
app-header-column-growing-conditions {
  display: contents;
}
/*# sourceMappingURL=header-column-growing-conditions.component.css.map */
